/**
 * Header Premium — tiroir (optionnel si le script inline est déjà dans header-premium.liquid)
 */
(function () {
  if (window.__headerPremiumDrawerBound) return;
  window.__headerPremiumDrawerBound = true;

  function run() {
    var burger = document.getElementById("header-premium-burger");
    var drawer = document.getElementById("header-premium-drawer");
    if (!burger || !drawer) return;

    function open() {
      document.body.classList.add("header-premium-drawer-open");
      burger.setAttribute("aria-expanded", "true");
      drawer.setAttribute("aria-hidden", "false");
      drawer.removeAttribute("inert");
      burger.classList.add("header-premium__burger--open");
    }

    function close() {
      document.body.classList.remove("header-premium-drawer-open");
      burger.setAttribute("aria-expanded", "false");
      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
      burger.classList.remove("header-premium__burger--open");
      burger.focus();
    }

    function isOpen() {
      return document.body.classList.contains("header-premium-drawer-open");
    }

    burger.addEventListener("click", function (e) {
      e.preventDefault();
      if (isOpen()) close();
      else open();
    });

    drawer.querySelectorAll("[data-header-drawer-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });

    drawer.querySelectorAll(".header-premium__drawer-link, .header-premium__drawer-sublink").forEach(function (a) {
      a.addEventListener("click", close);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) close();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
